export default __webpack_public_path__ + "moin-app-illus-no-chat-messages.24ffe95d91024322da036ae256ea7f2b.png";